
import { Component, Vue } from "vue-property-decorator";
import { copyToClipboard, Notify } from "quasar";
@Component
export default class TheFooter extends Vue {
  private logoUno =
    process.env.VUE_APP_AWS_ASSETS + "/logos/logo_uno_footer.png";
  private logoDos =
    process.env.VUE_APP_AWS_ASSETS + "/logos/logo_dos_footer.png";
  private logoFacebook = process.env.VUE_APP_AWS_ASSETS + "/logos/facebook.png";
  private logoX = process.env.VUE_APP_AWS_ASSETS + "/logos/twitter.png";
  private logoYoutube = process.env.VUE_APP_AWS_ASSETS + "/logos/youtube.png";
  private copiarClipboard(texto: any) {
    copyToClipboard(texto)
      .then(() => {
        Notify.create({
          color: "positive",
          message: "Se ha copiado el Número de Teléfono.",
          icon: "report_problem",
          position: "top",
          timeout: 2500,
        });
        return;
      })
      .catch(() => {
        Notify.create({
          color: "negative",
          message: "Ha ocurrido un problema. Por favor, inténtelo de nuevo.",
          icon: "report_problem",
          position: "top",
          timeout: 2500,
        });
        return;
      });
  }

  private irLink(link) {
    window.open(link, "_blank");
  }

  private irPreguntasFrecuentes() {
    this.$router.push("/preguntas-frecuentes");
  }

  private irHome() {
    this.$router.push("/");
  }

  private llamar(data: any) {
    const numero = data;
    window.open("tel:" + numero);
  }
}
